module.exports = __webpack_public_path__ + "static/infographic.ce007f34.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/infographic.png
// module id = ./src/images/infographic.png
// module chunks = 87192162464282